function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import deepFreeze from 'deep-freeze-strict';
import _ from 'lodash/fp';

var fp = _.noConflict();

import Ncs from '../index';

function httpQuery(url, params) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return fetch(url, params).then(function (r) {
    if (r.status === 200) {
      return r;
    } else if (r.status === 202) {
      var timeoutIndex = Math.min(n, Ncs.config.result.retryTimeouts.length - 1);
      var timeout = Ncs.config.result.retryTimeouts[timeoutIndex];
      return new Promise(function (resolve) {
        return setTimeout(resolve, timeout);
      }).then(function () {
        return httpQuery(url, params, n + 1);
      });
    } else {
      return Promise.reject(r.status);
    }
  });
}

function httpQueryParams(mimeType, query) {
  return {
    method: 'POST',
    headers: {
      'Accept': mimeType,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(query)
  };
}

function executeQuery(resultType, query, commit, dispatch) {
  if (!validateQuery(resultType, query, commit)) return;
  commit('running', query);

  if (!window.ncs_log_queries) {
    var url = "".concat(Ncs.config.app.relative_url_root).concat(Ncs.config.result.apiPath, "/").concat(Ncs.config.result[resultType].endpoint);
    return httpQuery(url, httpQueryParams('application/json', query)).then(function (r) {
      return r.json();
    }).then(function (r) {
      return completedCallbacks(query, r, commit, dispatch);
    }, function (e) {
      return commit('error', e);
    });
  } else {
    // If window.ncs_log_queries is set queries are logged instead of executed.
    console.log(_objectSpread({
      query: Ncs.config.result[resultType].endpoint
    }, query));
    commit('error', 'Logging query');
  }
}

function executeDownloadQuery(resultType, query, mimeType) {
  var url = "".concat(Ncs.config.app.relative_url_root).concat(Ncs.config.result.apiPath, "/").concat(Ncs.config.result[resultType].endpoint);
  return httpQuery(url, httpQueryParams(mimeType, query)).then(function (r) {
    return r.blob();
  });
}

function executeFullDownloadQuery(resultType, query, mimeType) {
  var url = "".concat(Ncs.config.app.relative_url_root).concat(Ncs.config.result.apiPath, "/download/").concat(Ncs.config.result[resultType].endpoint);
  return httpQuery(url, httpQueryParams(mimeType, query)).then(function (r) {
    return r.blob();
  });
} // Simple query validation. Returns true if the query is valid.
// Sets as error the final part of the error i18n key


function validateQuery(resultType, query, commit) {
  var distancesAllowed = fp.getOr(false, 'elements.distances', Ncs.config.result[resultType]);
  var someElementAllowed = fp.getOr(false, 'elements.minimum', Ncs.config.result[resultType]) > 0;
  var isDistances = fp.getOr(false, 'elements.distance', query);
  var leftElementsEmpty = fp.getOr([], 'elements.left', query).length === 0;
  var rightElementsEmpty = fp.getOr([], 'elements.right', query).length === 0;

  if (distancesAllowed && isDistances && (leftElementsEmpty || rightElementsEmpty)) {
    commit('error', 'empty_elements_distance');
    return false;
  } else if (someElementAllowed && leftElementsEmpty) {
    commit('error', 'empty_elements');
    return false;
  }

  return true;
}

function completedCallbacks(query, result, commit, dispatch) {
  commit('completed', result);
  commit('pagination/apiCompleteCallback', {
    query: query,
    result: result
  }, {
    root: true
  });
  dispatch('history/push', null, {
    root: true
  });
}

function setResultType(state, type) {
  // If the current resultType is a detail type store the current result type as parent
  state.parentResultType = fp.includes(type)(Ncs.config.result.detailTypes) ? state.resultType : null;
  state.resultType = type;
  state.resultDisplay = Ncs.config.result[state.resultType].defaultDisplay || type;
  state.executionState = null;
  state.result = null;
}

export default {
  namespaced: true,
  state: {
    resultType: null,
    parentResultType: null,
    resultDisplay: null,
    executionState: null,
    error: null,
    query: null,
    result: null,
    customQueryParameters: {}
  },
  mutations: {
    setResultType: setResultType,
    setResultDisplay: function setResultDisplay(s, d) {
      s.resultDisplay = d || s.defaultDisplay;
    },
    // Additional elements to be included in the query object.
    setCustomQueryParameters: function setCustomQueryParameters(s, p) {
      s.customQueryParameters = _objectSpread({}, s.customQueryParameters, {}, p);
    },
    running: function running(s, q) {
      s.executionState = 'running';
      s.query = q;
    },
    completed: function completed(s, r) {
      s.result = deepFreeze(r);
      s.error = null;
      s.executionState = 'completed';
    },
    error: function error(s, e) {
      s.result = null;
      s.error = e;
      s.executionState = 'error';
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.query = v.query;
      s.result = deepFreeze(v.result);
      s.parentResultType = v.parentResultType;
      s.resultType = v.resultType;
      s.resultDisplay = v.resultDisplay;
    }
  },
  getters: {
    buildQuery: function buildQuery(s, g, rs, rg) {
      return _objectSpread({
        filters: rg['filters/query'],
        elements: rg['elements/query'],
        pagination: rg['pagination/query'],
        order: rg['order/query'],
        groups: rg['groups/query'],
        frequency_groups: rg['frequency_groups/query']
      }, s.customQueryParameters);
    },
    elementType: function elementType(_s, _g, _rs, rg) {
      return rg['elements/query'].type;
    },
    resultType: function resultType(s) {
      return s.resultType;
    },
    formResultType: function formResultType(s) {
      // Return the form result type: If the result type is a detail type, return the parent result type.
      // Form behaviour for detail types should be the same as for their parent result.
      return fp.includes(s.resultType)(Ncs.config.result.detailTypes) ? s.parentResultType : s.resultType;
    },
    snapshot: function snapshot(s) {
      return {
        query: s.query,
        result: s.result,
        parentResultType: s.parentResultType,
        resultType: s.resultType,
        resultDisplay: s.resultDisplay
      };
    }
  },
  actions: {
    execute: function execute(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          rootGetters = _ref.rootGetters;
      if (state.executionState === 'running') return;
      var query = getters.buildQuery; // A query executed from a detail type will execute and change the result type to parent
      // (that corresponds to the result type that determines the form behaviour)
      // Example: After accessing a KWIC context press "Search" button.
      // A new KWIC query should be launched not a context one.

      commit('setResultType', getters.formResultType);
      return executeQuery(state.resultType, query, commit, dispatch);
    },
    executeDetail: function executeDetail(_ref2, _ref3) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters;
      var type = _ref3.type,
          query = _ref3.query;
      if (state.executionState === 'running') return;
      commit('setResultType', type);
      return executeQuery(type, query, commit, dispatch);
    },
    executeDownload: function executeDownload(_ref4, _ref5) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch,
          commit = _ref4.commit,
          getters = _ref4.getters,
          rootGetters = _ref4.rootGetters,
          rootState = _ref4.rootState;
      var mimeType = _ref5.mimeType;
      if (state.executionState !== 'completed') return;
      if (!Ncs.config.result[getters.resultType].pagination) return; // Download query is the previous result query but with current selected frequency_groups.

      var query = _objectSpread({}, state.query, {
        frequency_groups: rootGetters['frequency_groups/query']
      });

      return executeDownloadQuery(state.resultType, query, mimeType);
    },
    executeFullDownload: function executeFullDownload(_ref6, _ref7) {
      var state = _ref6.state,
          dispatch = _ref6.dispatch,
          commit = _ref6.commit,
          getters = _ref6.getters,
          rootGetters = _ref6.rootGetters,
          rootState = _ref6.rootState;
      var mimeType = _ref7.mimeType;
      if (state.executionState !== 'completed') return;
      if (!Ncs.config.result[getters.resultType].pagination) return; // Download query is the previous result query but with current selected frequency_groups.

      var query = _objectSpread({}, state.query, {
        frequency_groups: rootGetters['frequency_groups/query']
      });

      return executeFullDownloadQuery(state.resultType, query, mimeType);
    },
    setResultType: function setResultType(_ref8, resultType) {
      var state = _ref8.state,
          dispatch = _ref8.dispatch,
          commit = _ref8.commit,
          getters = _ref8.getters,
          rootGetters = _ref8.rootGetters,
          rootState = _ref8.rootState;
      commit('setResultType', resultType); // If selected resultType is not valid for elements or distances, reset elements

      var validElements = fp.includes(rootState.elements.type)(Ncs.config.result[resultType].elements.types);
      var validDistances = !rootState.elements.distance.type || Ncs.config.result[resultType].elements.distances;

      if (!validElements || !validDistances) {
        dispatch('elements/reset', null, {
          root: true
        });
      }

      dispatch('order/setDefault', null, {
        root: true
      });
      dispatch('groups/setDefault', null, {
        root: true
      });
      dispatch('frequency_groups/setDefault', null, {
        root: true
      });
    },
    reset: function reset(_ref9) {
      var state = _ref9.state,
          dispatch = _ref9.dispatch,
          commit = _ref9.commit,
          getters = _ref9.getters,
          rootGetters = _ref9.rootGetters;
      var resultType = Ncs.config.result.defaultType;
      dispatch('setResultType', resultType);
      commit('setResultDisplay', Ncs.config.result[Ncs.config.result.defaultType].defaultDisplay || resultType);
    }
  }
};